import { request } from 'Features/auth/axios-client'
import { useMutation, useQuery, useQueryClient } from 'react-query'

const fetchSettingsTableData = async (planId: string, table: string) => {
  const { data } = await request({
    url: `plan/${planId}/table/${table}`,
    method: 'GET',
  })
  return data
}

export const useSettingsTableData = (planId: string, table: string) => {
  return useQuery(
    ['edit-settings', table, planId],
    () => fetchSettingsTableData(planId, table),
    {
      enabled: true,
      select: ({ data }) => {
        return data
      },
      refetchOnWindowFocus: false,
      cacheTime: 0,
    }
  )
}

// Update table data
type UpdateTableDataProps = {
  planId: string
  table: string
  data: Record<string, any>
}
const updateTableData = async ({
  planId,
  table,
  data,
}: UpdateTableDataProps) => {
  const returnedData = await request({
    url: `plan/${planId}/table/${table}`,
    method: 'PUT',
    data,
  })
  return returnedData
}

export const useUpdateTableData = (
  onSuccess: () => void,
  onError: () => void
) => {
  return useMutation(updateTableData, {
    onSuccess: () => {
      onSuccess()
    },
    onError: () => {
      onError()
    },
  })
}

/*** Upload */

type UploadParametersProps = {
  file: File
  table: string
  planId: string
}
const uploadParameters = async ({
  file,
  table,
  planId,
}: UploadParametersProps) => {
  const formData = new FormData()
  formData.append('file', file)
  const { data } = await request({
    url: `plan/${planId}/table/${table}`,
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return data
}

export const useUploadParameters = (
  onUploadSuccess: () => void,
  onUploadFailure: () => void
) => {
  const queryClient = useQueryClient()
  return useMutation(uploadParameters, {
    onSuccess: (data, variables: UploadParametersProps) => {
      queryClient.invalidateQueries([
        'edit-settings',
        variables.table,
        variables.planId,
      ])
      onUploadSuccess()
    },
    onError: () => {
      onUploadFailure()
    },
  })
}
